namespace $.$$ {

	$mol_style_define( $shm_hitalama_process_view, {

		display: 'flex',
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
		padding: $mol_gap.block,

		Head: {
			display: 'flex',
			flex: {
				wrap: 'wrap',
			},
			align: {
				items: 'baseline',
			},
			gap: $mol_gap.text,
		},

		Title: {
			font: {
				weight: 600,
				size: '1.1rem',
			},
		},

		Method: {
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
				size: '.85rem',
			},
			wordBreak: 'break-all',
		},

		Stats: {
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fit, minmax(7rem, 1fr))',
			gap: $mol_gap.text,
		},

		Stat_total: {
			padding: $mol_gap.text,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			gap: $mol_gap.block,
		},

		Stat_last: {
			padding: $mol_gap.text,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			gap: $mol_gap.block,
		},

		Stat_duration: {
			padding: $mol_gap.text,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			gap: $mol_gap.block,
		},

		Stat_total_label: {
			color: $mol_theme.shade,
			font: {
				size: '.75rem',
			},
		},

		Stat_last_label: {
			color: $mol_theme.shade,
			font: {
				size: '.75rem',
			},
		},

		Stat_duration_label: {
			color: $mol_theme.shade,
			font: {
				size: '.75rem',
			},
		},

		Stat_total_value: {
			font: {
				weight: 600,
			},
		},

		Stat_last_value: {
			font: {
				weight: 600,
			},
		},

		Stat_duration_value: {
			font: {
				weight: 600,
			},
		},

		Empty: {
			color: $mol_theme.shade,
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
		},

		Running_fiber_row: {
			display: 'flex',
			align: {
				items: 'flex-start',
			},
			gap: $mol_gap.text,
			pointerEvents: 'auto',
		},

		Running_fiber: {
			padding: $mol_gap.text,
			opacity: 0.6,
			font: {
				family: 'monospace',
			},
			wordBreak: 'break-all',
			flex: {
				grow: 1,
			},
		},

		Running_fiber_copy: {
			flex: {
				shrink: 0,
			},
		},

		Calls: {
			gap: $mol_gap.block,
		},

		Call_card: {
			padding: $mol_gap.block,
			gap: $mol_gap.text,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			overflow: 'hidden'
		},

		Call_head: {
			display: 'flex',
			flex: {
				wrap: 'wrap',
			},
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
		},

		Call_status: {
			padding: {
				top: '.15rem',
				bottom: '.15rem',
				left: '.45rem',
				right: '.45rem',
			},
			border: {
				radius: $mol_gap.round,
			},
			background: {
				color: $mol_theme.line,
			},
			font: {
				size: '.75rem',
				weight: 600,
			},
			textTransform: 'uppercase',
		},

		Call_name: {
			flex: {
				grow: 1,
			},
			font: {
				family: 'monospace',
			},
			wordBreak: 'break-all',
		},

		Call_duration: {
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
			},
		},

		Call_time: {
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
				size: '.85rem',
			},
		},

		Call_args: {
			userSelect: 'text',
		},

		Call_result: {
			userSelect: 'text',
		},

		Call_error: {
			userSelect: 'text',
			color: '#e05050',
		},

	} )

}
